import styled from 'styled-components';
import type { DeliveryAndKlarna as DeliveryAndKlarnaSchema } from '@amplience/content-types/typings/c-delivery-and-klarna';
import { ImagePartial } from '@storefront/lib-global/partials/image';
import { media, spacing } from '@storefront/lib-global/stylings';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';

const S = {
  ComponentList: styled.ul`
    margin: 20px 0 0;
    max-width: 522px;
    padding: 0;

    @media ${media.greaterThan('lg')} {
      margin: ${spacing.M} 0 0;
    }
  `,
  ComponentItemBar: styled.li`
    display: flex;
    gap: ${spacing.S};
    margin-top: ${spacing.XS};

    &:nth-of-type(1) {
      margin-top: unset;
    }
  `,
  IconContainer: styled.div`
    flex-shrink: 0;
    position: relative;
  `,
  TextInfo: styled.span`
    align-items: center;
    display: flex;
    line-height: 28px;
    max-width: 310px;
    min-height: 24px;
    word-break: break-word;
  `,
};

export type DeliveryAndKlarnaProps = DeliveryAndKlarnaSchema;

export function DeliveryAndKlarna({ deliveryAndKlarnaList }: DeliveryAndKlarnaProps) {
  return (
    <S.ComponentList>
      {deliveryAndKlarnaList?.map((item) => (
        <S.ComponentItemBar key={item.image.image?.name}>
          <S.IconContainer>
            {item.image && (
              <ImagePartial
                layout="intrinsic"
                altText={item.image?.altText}
                src={item.image.image?.name ?? ''}
                assetType={item.image.assetType}
                height={item.image && 24}
                width={item.image && 24}
                defaultHost={item.image.image?.defaultHost}
                useOriginalSize={item.image.useOriginalSize}
              />
            )}
          </S.IconContainer>
          <S.TextInfo>{getLocalizedValue(item.infoText?.deliveryAndKlarnaText)}</S.TextInfo>
        </S.ComponentItemBar>
      ))}
    </S.ComponentList>
  );
}
